import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const SearchContainer = styled.div`
  position: relative;
  width: 100%;

  .search-input {
    width: 100%;
    padding: 5px;
    font-size: 1rem;
    border-radius: 5px;
    border: none;
    outline: none;
  }

  .autocomplete-list {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    background-color: white;
    border: 1px solid #ddd;
    border-top: none;
    z-index: 1000;
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .autocomplete-item {
    padding: 8px;
    cursor: pointer;
    
    &:hover {
      background-color: #f0f0f0;
    }
  }
`;

const SearchAutocomplete = ({ onSelectRoute }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showAutocomplete, setShowAutocomplete] = useState(false);
  const navigate = useNavigate();

  const searchOptions = [
    // Rutas de navegación principal
    { label: 'Casa', route: '/es/home' },
    { label: 'Nosotros', route: '/es/about' },
    { label: 'Contacto', route: '/es/contact' },
    { label: 'Productos', route: '/products' },
    
    // Rutas de usuario
    { label: 'Iniciar Sesión', route: '/es/login' },
  
    
    // Rutas específicas de productos
    { label: 'Coronas', route: '/products/crowns' },
    { label: 'Coves', route: '/products' },
    { label: 'Codos', route: '/products' },
    { label: 'Camas', route: '/products' },
    { label: 'Casung', route: '/products' },
    { label: 'Paradas', route: '/products' }
  ];

  const filteredOptions = searchOptions.filter(option => 
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setShowAutocomplete(value.length > 0);
  };

  const handleSelectOption = (option) => {
    setSearchTerm(option.label);
    setShowAutocomplete(false);
    
    // Navegar a la ruta seleccionada
    navigate(option.route);
  };

  return (
    <SearchContainer>
      <input 
        type="text" 
        className="search-input"
        placeholder="Buscar..." // Cambiado a español
        value={searchTerm}
        onChange={handleInputChange}
        onFocus={() => setShowAutocomplete(searchTerm.length > 0)}
        onBlur={() => setTimeout(() => setShowAutocomplete(false), 200)}
      />
      {showAutocomplete && filteredOptions.length > 0 && (
        <ul className="autocomplete-list">
          {filteredOptions.map((option, index) => (
            <li 
              key={index} 
              className="autocomplete-item"
              onClick={() => handleSelectOption(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </SearchContainer>
  );
};

export default SearchAutocomplete;
